import React, { useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";

import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import Measurement_Uncertainty_Report_Table from "./measurement_uncertainty_report_table/Measurement_Uncertainty_Report_Table";
import Measurement_Uncertainty_Report_Filter from "./measurement_uncertainty_report_filter/Measurement_Uncertainty_Report_Filter";

const Measurement_Uncertainty_Report = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Measurement Uncertainty Report" />
      </div>

      <div className="Sample_Report_Filter_div">
        <Measurement_Uncertainty_Report_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Measurement_Uncertainty_Report_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Measurement Uncertainty Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Measurement_Uncertainty_Report;
